import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/user_dashboard/ic_fb.svg'
import _imports_1 from '@/assets/img/user_dashboard/ic_linkedIn.svg'
import _imports_2 from '@/assets/img/user_dashboard/ic_insta.svg'
import _imports_3 from '@/assets/img/user_dashboard/ic_twitter.svg'


const _withScopeId = n => (_pushScopeId("data-v-0cf829f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lg:w-3/4 mx-auto space-y-4 mb-5 lg:px-0 px-4 mt-20 flex md:flex-row flex-col items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex-grow mt-5 text-sm font-light text-gray-600" }, " Copyrights © 2026 All rights reserved by MYLE ", -1))
const _hoisted_3 = { class: "sm:flex-none flex items-center space-x-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "cursor-pointer",
    src: "/assets/images/user_dashboard/ic_email.svg",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "cursor-pointer flex space-x-4 font-normal text-green-500 hover:text-green-600 items-center py-4" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:hello@myle.com" }, "hello@myle.com")
  ])
], -1))
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cursor-pointer h-4",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cursor-pointer h-4",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cursor-pointer h-4",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cursor-pointer h-4",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("a", {
        class: "cursor-pointer",
        href: 'https://www.facebook.com/MYLEMARKERS',
        target: "_blank"
      }, _hoisted_7, 8, _hoisted_5),
      _createElementVNode("a", {
        class: "cursor-pointer",
        href: 'https://www.linkedin.com/company/myle/',
        target: "_blank"
      }, _hoisted_10, 8, _hoisted_8),
      _createElementVNode("a", {
        class: "cursor-pointer",
        href: 'https://www.instagram.com/mylemarkers/',
        target: "_blank"
      }, _hoisted_13, 8, _hoisted_11),
      _createElementVNode("a", {
        class: "cursor-pointer",
        href: 'https://twitter.com/MYLEMARKERS',
        target: "_blank"
      }, _hoisted_16, 8, _hoisted_14)
    ])
  ]))
}